import siteRequest from '../../helpers/siteRequest';

const ticketsRequest = () => {
    return { type: 'TICKETS_REQUEST' };
};

const ticketsSuccess = (tickets, count) => {
    return { type: 'TICKETS_SUCCESS', tickets, count };
};

const ticketsFailure = error => {
    return {
        type: 'TICKETS_FAILURE',
        error
    };
};

const tickets = (
    pageNumber,
    perPage,
    status,
    order,
    searchText
) => async dispatch => {
    try {
        dispatch(ticketsRequest());

        const response = await siteRequest({
            method: 'get',
            url: '/wp-json/hamyar-faq/v1/tickets',
            params: {
                page: pageNumber,
                per_page: perPage,
                status,
                order,
                s: searchText
            }
        });

        dispatch(ticketsSuccess(response.data, response.data_count));

        return Promise.resolve(response.data);
    } catch (error) {
        dispatch(ticketsFailure(error));
    }
};

const ticketsSpamRequest = () => {
    return { type: 'TICKETS_SPAM_REQUEST' };
};

const ticketsSpamSuccess = () => {
    return { type: 'TICKETS_SPAM_SUCCESS' };
};

const ticketSpamFailure = error => {
    return {
        type: 'TICKETS_SPAM_FAILURE',
        error
    };
};

const ticketsSpam = (id, type) => async dispatch => {
    try {
        dispatch(ticketsSpamRequest());

        const response = await siteRequest({
            method: 'post',
            url: `/wp-json/hamyar-faq/v1/tickets/${id}`,
            data: {
                type
            }
        });

        dispatch(ticketsSpamSuccess());
    } catch (error) {
        dispatch(ticketSpamFailure(error));
    }
};

const ticketsPrivateRequest = () => {
    return { type: 'TICKETS_PRIVATE_REQUEST' };
};

const ticketsPrivateSuccess = () => {
    return { type: 'TICKETS_PRIVATE_SUCCESS' };
};

const ticketsPrivateFailure = error => {
    return {
        type: 'TICKETS_PRIVATE_FAILURE',
        error
    };
};

const ticketsPrivate = (id, type) => async dispatch => {
    try {
        dispatch(ticketsPrivateRequest());
        const response = await siteRequest({
            method: 'post',
            url: `/wp-json/hamyar-faq/v1/tickets/${id}`,
            data: {
                type
            }
        });

        dispatch(ticketsPrivateSuccess());
    } catch (error) {
        dispatch(ticketsPrivateFailure(error));
    }
};

const ticketsCloseRequest = () => {
    return { type: 'TICKETS_CLOSE_REQUEST' };
};

const ticketsCloseSuccess = () => {
    return { type: 'TICKETS_CLOSE_SUCCESS' };
};

const ticketsCloseFailure = error => {
    return {
        type: 'TICKETS_CLOSE_FAILURE',
        error
    };
};

const ticketsClose = (id, status) => async dispatch => {
    try {
        dispatch(ticketsCloseRequest());

        const response = await siteRequest({
            method: 'post',
            url: `/wp-json/hamyar-faq/v1/tickets/${id}`,
            data: {
                status
            }
        });

        dispatch(ticketsCloseSuccess());
    } catch (error) {
        dispatch(ticketsCloseFailure(error));
    }
};

const ticketsDeleteRequest = () => {
    return { type: 'TICKETS_DELETE_REQUEST' };
};

const ticketsDeleteSuccess = id => {
    return { type: 'TICKETS_DELETE_SUCCESS', id };
};

const ticketsDeleteFailure = error => {
    return {
        type: 'TICKETS_DELETE_FAILURE',
        error
    };
};

const ticketsDelete = id => async dispatch => {
    try {
        dispatch(ticketsDeleteRequest());

        await siteRequest({
            method: 'delete',
            url: `/wp-json/hamyar-faq/v1/tickets/${id}`
        });

        dispatch(ticketsDeleteSuccess(id));
    } catch (error) {
        dispatch(ticketsDeleteFailure(error));
    }
};

const getTicketRequest = () => {
    return { type: 'TICKET_GET_REQUEST' };
};

const getTicketSuccess = id => {
    return { type: 'TICKET_GET_SUCCESS', id };
};

const getTicketFailure = error => {
    return {
        type: 'TICKET_GET_FAILURE',
        error
    };
};

const getTicket = id => async dispatch => {
    try {
        dispatch(getTicketRequest());

        const response = await siteRequest({
            method: 'get',
            url: `/wp-json/hamyar-faq/v1/tickets/${id}/replies`
        });

        dispatch(getTicketSuccess(id));

        return Promise.resolve(response);
    } catch (error) {
        dispatch(getTicketFailure(error));
    }
};

const sendTicketRequest = () => {
    return { type: 'TICKET_SEND_REQUEST' };
};

const sendTicketSuccess = () => {
    return { type: 'TICKET_SEND_SUCCESS' };
};

const sendTicketFailure = error => {
    return {
        type: 'TICKET_SEND_FAILURE',
        error
    };
};

const sendTicket = (id, type, content) => async dispatch => {
    try {
        dispatch(sendTicketRequest());

        const response = await siteRequest({
            method: 'post',
            url: `/wp-json/hamyar-faq/v1/tickets/${id}/replies`,
            data: {
                type,
                content
            }
        });

        dispatch(sendTicketSuccess());

        return Promise.resolve(response.data);
    } catch (error) {
        dispatch(sendTicketFailure(error));
    }
};

const deleteReplayRequest = () => {
    return { type: 'DELETE_REPLAY_REQUEST' };
};

const deleteReplaySuccess = () => {
    return { type: 'DELETE_REPLAY_SUCCESS' };
};

const deleteReplayFailure = error => {
    return {
        type: 'DELETE_REPLAY_FAILURE',
        error
    };
};

const deleteReplay = (ticketID, replayID) => async dispatch => {
    try {
        dispatch(deleteReplayRequest());

        const response = await siteRequest({
            method: 'delete',
            url: `/wp-json/hamyar-faq/v1/tickets/${ticketID}/replies`,
            data: {
                reply_id: replayID
            }
        });

        dispatch(deleteReplaySuccess());
    } catch (error) {
        dispatch(deleteReplayFailure(error));
    }
};

const sendVoiceTicketRequest = () => {
    return { type: 'TICKET_SEND_REQUEST' };
};

const sendVoiceTicketSuccess = () => {
    return { type: 'TICKET_SEND_SUCCESS' };
};

const sendVoiceTicketFailure = error => {
    return {
        type: 'TICKET_SEND_FAILURE',
        error
    };
};

const sendVoiceTicket = (id, data) => async dispatch => {
    try {
        dispatch(sendVoiceTicketRequest());

        const response = await siteRequest({
            method: 'post',
            url: `/wp-json/hamyar-faq/v1/tickets/${id}/replies`,
            data,
            params: {
                content: 'audio',
                type: 'audio'
            }
        });

        dispatch(sendVoiceTicketSuccess());
    } catch (error) {
        dispatch(sendVoiceTicketFailure(error));
    }
};

const questionsCountRequestSuccess = (data) => {
    return { type: 'GET_REGISTERED_TICKET_SUCCESS', data };
};

const questionsCountRequestFailure = () => {
    return { type: 'GET_REGISTERED_TICKET_FAILURE' };
};

const getRegisteredQuestionCount = () => async dispatch => {
    try {
        const res = await siteRequest({
            method: 'get',
            url: `/wp-json/hamyar-faq/v1/tickets/status`,
        });
        dispatch (questionsCountRequestSuccess(res.data));

        return Promise.resolve(res.data);
    } catch (e) {
        dispatch (questionsCountRequestFailure);
    }
};

export {
    ticketsRequest,
    ticketsSuccess,
    ticketsFailure,
    ticketsSpamRequest,
    ticketsSpamSuccess,
    ticketSpamFailure,
    ticketsPrivateRequest,
    ticketsPrivateSuccess,
    ticketsPrivateFailure,
    ticketsCloseRequest,
    ticketsCloseSuccess,
    ticketsCloseFailure,
    ticketsDeleteRequest,
    ticketsDeleteSuccess,
    ticketsDeleteFailure,
    getTicketRequest,
    getTicketSuccess,
    getTicketFailure,
    sendTicketRequest,
    sendTicketSuccess,
    sendTicketFailure,
    deleteReplayRequest,
    deleteReplaySuccess,
    deleteReplayFailure,
    tickets,
    ticketsSpam,
    ticketsPrivate,
    ticketsClose,
    ticketsDelete,
    getTicket,
    sendTicket,
    deleteReplay,
    sendVoiceTicket,
    getRegisteredQuestionCount,
};
